
import { useEffect } from 'react';
import s from './Layout.module.css';
import { Link, Outlet } from 'react-router-dom';
import { CreateDealDto, DealDto } from '../../../../shared/swagger/client/api-client';
import { newDealsData } from '../../../../entities/model/Deals';


export type InitOfferChatOptions = {
  containerDivId?: string;
  containerAdminDivId?: string;
  clientId?: string;
  bearerToken: string;
  deal?: DealDto;
  pageUrl: string;
  mode?: 'main' | 'admin';
  newDeals?: CreateDealDto[];
};

export const AdminLayout = () => {
  useEffect(() => {
      if (window.OfferChat) {
        const sellerInit: InitOfferChatOptions = {
          bearerToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiIxMCIsImVtYWlsIjoic2VsbGVyQGR1cG9udC5jb20iLCJmaXJzdE5hbWUiOiJKb2huIiwibGFzdE5hbWUiOiJEb2UiLCJzdGF0ZSI6IkZMIiwiemlwQ29kZSI6IjM0NDAxIiwicGhvbmUiOiIxMjM0NTY3ODkwIiwiaWF0IjoxNzM3Mzk1MjgyLCJleHAiOjIwMzc0Njg4OTksInR5cGUiOiJzZWxsZXIifQ.WR_vxp7GiRlOYcBxrWDz9SqnXoQ9MxlbkPNQRLuNPSc',
          // bearerToken: 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIxMSIsImVtYWlsIjoiYnV5ZXIxMUBkdXBvbnRyZWdlc3RyeS5jb20iLCJmaXJzdE5hbWUiOiJQYWJsbyIsImxhc3ROYW1lIjoiVXNvdiIsInN0YXRlIjoiRkwiLCJ6aXBDb2RlIjoiMzQ0MDEiLCJwaG9uZSI6IjEyMzQ1Njc4OTAiLCJpYXQiOjE3MzczOTUyODIsImV4cCI6MjAzNzQ2ODg5OX0.64dTrzwFHcfHQx_nU4GTfGYkB5ixmL7nbcTZU0nabRU',
          containerAdminDivId: 'offer-chat-admin',
          pageUrl: 'https://testing-new.dupontregistry.com/autos/listing/2022/lamborghini/aventador/29981',
          mode: 'admin',
          clientId: 'dupont-client',
          newDeals: newDealsData,
        };

        window.OfferChat.init(sellerInit);
      }
    }, []);

  return (
     <div className={s.layout}>
      <header className={s.header}>
        <div className={s.logo}>Tenant Price Chats</div>
        <div className={s.headerControls}>
          <div className={s.profileInfo}>Admin User</div>
        </div>
      </header>
      <div className={s.container}>
        <aside className={s.sidebar}>
          <nav className={s.navigation}>
            <div className={s.navList}>
              <Link className={s.navItem} to="/admin">Deals</Link>
              <Link className={s.navItem} to="/admin/offers">Offers</Link>
            </div>
          </nav>
        </aside>
        <main className={s.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};
